module.exports = __webpack_public_path__ + "img/crude_oil.faf2a1a.jpg";